<template>
      <v-card style="overflow:hidden" :img="require('../assets/dark parchment background.jpg')">
        <v-card-title class="headline brown darken-4 white--text"> 
          Hidden Items
        </v-card-title>
        <v-card v-for="item in items" :key="item.id" class="my-2">
            <span v-if="item.hidden">
                <picker-card :item="item" @hideItem="$emit('hideItem', item)"></picker-card>
            </span>
        </v-card>
      </v-card>    
</template>

<script>
import PickerCard from "./PickerCard"
export default {
    components: {
      PickerCard,
    },
    props:{
        type:String,
        items:[]
    },
    data(){
      return{
      }
    },
    mounted(){ 
        this.items.forEach(item => {
          if(item.hidden){
            console.log(item.name)
          }  
        })
    },
    watch:{

    },
        
    methods:{
    
    }
}
</script>

<style>
.small-label .v-label{
  font-size:12px;
  margin-top:0px;
  margin-bottom:0px;
  padding-top:0px;
}
.small-label .v-messages.theme--light{
  height:0px;
  display:none;
}
.small-label .v-input--selection-controls__input{
  margin-right: 0px !important
}
</style>